import React, { useContext, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PerformerAWContext } from "../contexts/PerformerAWContext";

const Stories = () => {
  const { performers: performersAW, loading: loadingAW } = useContext(PerformerAWContext);
  const scrollRef = useRef(null);

  const handleScrollLeft = () => { if (scrollRef.current) scrollRef.current.scrollLeft -= 200; };
  const handleScrollRight = () => { if (scrollRef.current) scrollRef.current.scrollLeft += 200; };

  // Only show performers that have a valid image URL
  const performers = (performersAW || []).filter(p => p.profilePictureFullUrl || p.profilePictureUrl);

  if (loadingAW || performers.length === 0) {
    return null; // Don't show the row if nothing to show
  }

  return (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center", width: "100%", mb: 1 }}>
      <IconButton
        onClick={handleScrollLeft}
        sx={{ position: "absolute", left: 0, zIndex: 1, backgroundColor: "rgba(0,0,0,0.5)",
          color: "#fff", "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }, p: 0.5 }}
      >
        <ArrowBackIosIcon fontSize="small" />
      </IconButton>

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          width: "100%",
          padding: "8px 40px",
          gap: "12px",
        }}
      >
        {performers.map((performer) => {
          const imgSrc = performer.profilePictureFullUrl || performer.profilePictureUrl;
          return (
            <Box
              key={performer.uniqueModelId || performer.performerId}
              onClick={() => performer.chatRoomUrl && window.open(performer.chatRoomUrl, '_blank')}
              sx={{ minWidth: 72, textAlign: "center", display: "flex",
                flexDirection: "column", alignItems: "center", cursor: "pointer",
                flexShrink: 0 }}
            >
              {/* Pink gradient ring */}
              <Box sx={{
                width: 66, height: 66,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #FF4196, #FF6B6B, #FFD200)",
                padding: "2px",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <Box sx={{
                  width: 60, height: 60, borderRadius: "50%",
                  border: "2px solid #1a1a2e",
                  overflow: "hidden", backgroundColor: "#222",
                }}>
                  <img
                    src={imgSrc}
                    alt={performer.displayName}
                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    onError={(e) => {
                      // Try fallback size, then hide
                      if (performer.profilePictureUrl && e.target.src !== performer.profilePictureUrl) {
                        e.target.src = performer.profilePictureUrl;
                      } else {
                        e.target.parentElement.style.backgroundColor = "#333";
                        e.target.style.display = "none";
                      }
                    }}
                  />
                </Box>
              </Box>
              <Typography sx={{
                color: "#fff", fontSize: "0.65rem", fontWeight: 700, mt: 0.5,
                overflow: "hidden", textOverflow: "ellipsis",
                maxWidth: 70, whiteSpace: "nowrap",
              }}>
                {performer.displayName}
              </Typography>
              <Typography sx={{ fontSize: "0.6rem", color: "#4CAF50" }}>● Live</Typography>
            </Box>
          );
        })}
      </Box>

      <IconButton
        onClick={handleScrollRight}
        sx={{ position: "absolute", right: 0, zIndex: 1, backgroundColor: "rgba(0,0,0,0.5)",
          color: "#fff", "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }, p: 0.5 }}
      >
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default Stories;
